import { twMerge } from "tailwind-merge";

import { Icon } from "./Icon";

export function Attention({ className }: { className?: string }) {
  return (
    <div className={twMerge("relative rounded-full bg-attention/20 p-3 text-attention", className)}>
      <div className="absolute size-6 rounded-full bg-attention/40 animate-duration-2000 motion-safe:animate-ping" />
      <Icon name="alert-circle" />
    </div>
  );
}
